import { useEffect, useState } from "react";
import {
    listarDeudas,
    crearDeuda,
    actualizarDeuda,
    listarCuotasDeuda,
    crearCuotaDeuda,
    actualizarCuotaDeuda,
    eliminarCuotaDeuda,
    pagarCuotaDeuda, eliminarDeuda,
} from "../api/deudaApi";

function normalizarDeuda(row) {
    return {
        ...row,
        idDeuda: row.idDeuda ?? row.id_deuda,
        montoInicial: Number(row.montoInicial ?? row.monto_inicial ?? 0),
        tasaInteres: row.tasaInteres ?? row.tasa_interes ?? "",
        saldoPendiente: Number(row.saldoPendiente ?? row.saldo_pendiente ?? 0),
        fechaInicio: row.fechaInicio ?? row.fecha_inicio ?? "",
        fechaFin: row.fechaFin ?? row.fecha_fin ?? "",
    };
}

function normalizarCuota(row) {
    return {
        ...row,
        idCuota: row.idCuota ?? row.id_cuota,
        idDeuda: row.idDeuda ?? row.id_deuda,
        numeroCuota: row.numeroCuota ?? row.numero_cuota,
        fechaVencimiento: row.fechaVencimiento ?? row.fecha_vencimiento ?? "",
        montoProgramado: Number(row.montoProgramado ?? row.monto_programado ?? 0),
        montoPagado: Number(row.montoPagado ?? row.monto_pagado ?? 0),
        fechaPago: row.fechaPago ?? row.fecha_pago ?? "",
        estado: row.estado ?? "PENDIENTE",
    };
}

export default function useDeudas() {
    const [deudas, setDeudas] = useState([]);
    const [cuotas, setCuotas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingCuotas, setLoadingCuotas] = useState(false);

    const cargar = async () => {
        setLoading(true);
        try {
            const data = await listarDeudas();
            setDeudas(Array.isArray(data) ? data.map(normalizarDeuda) : []);
        } catch (error) {
            console.error("Error cargando deudas:", error);
            setDeudas([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        cargar();
    }, []);

    const guardar = async (payload, idDeuda) => {
        if (idDeuda) {
            await actualizarDeuda(idDeuda, payload);
        } else {
            await crearDeuda(payload);
        }
        await cargar();
    };

    const verCuotas = async (idDeuda) => {
        setLoadingCuotas(true);
        try {
            const data = await listarCuotasDeuda(idDeuda);
            setCuotas(Array.isArray(data) ? data.map(normalizarCuota) : []);
        } catch (error) {
            console.error("Error cargando cuotas:", error);
            setCuotas([]);
        } finally {
            setLoadingCuotas(false);
        }
    };

    const agregarCuota = async (idDeuda, payload) => {
        await crearCuotaDeuda(idDeuda, payload);
        await verCuotas(idDeuda);
        await cargar();
    };

    const generarCuotas = async (idDeuda, cantidad, primerVencimiento, montoPorCuota) => {
        const baseDate = new Date(primerVencimiento + "T00:00:00");

        for (let i = 0; i < cantidad; i++) {
            const fecha = new Date(baseDate);
            fecha.setMonth(fecha.getMonth() + i);
            const yyyy = fecha.getFullYear();
            const mm = String(fecha.getMonth() + 1).padStart(2, "0");
            const dd = String(fecha.getDate()).padStart(2, "0");

            await crearCuotaDeuda(idDeuda, {
                numeroCuota: i + 1,
                fechaVencimiento: `${yyyy}-${mm}-${dd}`,
                montoProgramado: Number(montoPorCuota || 0),
                montoPagado: 0,
                estado: "PENDIENTE",
                fechaPago: null,
            });
        }

        await verCuotas(idDeuda);
        await cargar();
    };

    const editarCuota = async (idCuota, payload, idDeuda) => {
        await actualizarCuotaDeuda(idCuota, payload);
        await verCuotas(idDeuda);
    };

    const eliminarCuota = async (idCuota, idDeuda) => {
        await eliminarCuotaDeuda(idCuota);
        await verCuotas(idDeuda);
    };

    const pagarCuota = async (idCuota, payload, idDeuda) => {
        await pagarCuotaDeuda(idCuota, payload);
        await verCuotas(idDeuda);
        await cargar();
    };

    const eliminar = async (idDeuda) => {
        await eliminarDeuda(idDeuda);
        await cargar();
    };

    return {
        deudas,
        cuotas,
        loading,
        loadingCuotas,
        guardar,
        verCuotas,
        agregarCuota,
        generarCuotas,
        editarCuota,
        eliminarCuota,
        pagarCuota,
        eliminar,
        recargar: cargar,
    };
}